import { LoadingPage, SecondaryAction, Text, } from '@innovyze/stylovyze/lib/components';
import { PageWrapperContext } from '@innovyze/stylovyze/lib/hocs/PageWrapper/utils/PageWrapperContext';
import * as React from 'react';
import { useState } from 'react';
import * as Styled from './PageWrapper.styles';
import { Breadcrumbs, Link, Typography } from '@mui/material';
import { Link as RouterLink } from 'react-router-dom';
import { BackLink } from '../../components/BackLink';
function LinkRouter(props) {
    return (React.createElement(Link, { ...props, "data-cy": props.dataCy ?? props.to, component: RouterLink }));
}
/**
 * A wrapper for page level components in modules. Provides loading
 * capabilities and common styling (common styling coming soon)
 */
export const PageWrapper = (props) => {
    const { isLoading, children, applyPadding, titleIcon, title, back, secondary, secondaryNav, className, superHeader, subHeader, minorHeader, headerUnderline, secondaryAction, breadcrumbs, displayBackInBreadcrumbs = false, onlyShowSeveralTabs, } = props;
    const [showSecondaryAction, setShowSecondaryAction] = useState(false);
    const [isDirty, setIsDirty] = useState(false);
    const [pageWrapperStylovyzeFields, setPageWrapperStylovyzeFields] = useState({});
    return (React.createElement(PageWrapperContext.Provider, { value: {
            secondaryAction,
            pageWrapperStylovyzeFields,
            setPageWrapperStylovyzeFields,
            showSecondaryAction,
            setShowSecondaryAction,
            isDirty,
            setIsDirty,
        } },
        React.createElement(Styled.Wrapper, { applyPadding: applyPadding, isLoading: isLoading, id: "pageWrapper", className: className },
            breadcrumbs && breadcrumbs.length && title && (React.createElement(React.Fragment, null,
                displayBackInBreadcrumbs && React.createElement(Styled.ArrowBack, null),
                React.createElement(Breadcrumbs, { "aria-label": "breadcrumb", style: { display: 'inline-block' } },
                    breadcrumbs.map(crumb => (React.createElement(LinkRouter, { key: crumb.link, underline: "hover", color: "inherit", sx: {
                            fontSize: '0.8rem',
                        }, to: crumb.link, dataCy: crumb.dataCy }, crumb.title))),
                    React.createElement(Typography, { color: "text.primary", fontWeight: "bold", fontSize: "0.8rem" }, title)))),
            (title || secondary) && (React.createElement(Styled.HeaderSection, { secondaryNav: !!secondaryNav, headerUnderline: !!headerUnderline },
                title &&
                    (typeof title === 'string' ? (React.createElement(Styled.HeaderPrimary, null,
                        back && (React.createElement(BackLink, { label: back.label, onClick: back.action })),
                        superHeader &&
                            (typeof superHeader === 'string' ? (React.createElement(Text, { color: "secondary", variant: "caption-medium", dataCy: "page-header-super" }, superHeader)) : (superHeader)),
                        React.createElement(Styled.HeaderAndMinor, null,
                            titleIcon,
                            React.createElement(Text, { variant: "heading-large", dataCy: "page-header" }, title),
                            minorHeader &&
                                (typeof minorHeader === 'string' ? (React.createElement(Styled.HeaderMinor, { variant: "text-medium", color: "secondary", dataCy: "page-header-minor" }, minorHeader)) : (minorHeader))),
                        subHeader &&
                            (typeof subHeader === 'string' ? (React.createElement(Text, { color: "secondary", variant: "text-medium", dataCy: "page-header-sub" }, subHeader)) : (subHeader)))) : (title)),
                React.createElement(SecondaryAction, { action: secondary }))),
            secondaryNav && (React.createElement(Styled.Nav, { applyPadding: false, isLoading: isLoading, onlyShowSeveralTabs: onlyShowSeveralTabs, ...secondaryNav })),
            isLoading ? React.createElement(LoadingPage, null) : children)));
};
PageWrapper.defaultProps = {
    isLoading: false,
    applyPadding: false,
    back: false,
};
export default PageWrapper;
